import { INVALID_DATE } from "@/constants/invalids";
import { validator } from "@/utils/validator";
import { replaceStr } from "@/utils/string";

const invalidDate = (label: string) => replaceStr(INVALID_DATE, { path: label });

export const organizationFilterSchema = validator.object().shape({
  externalId: validator.string().emptyToNull().trim().max(20).label("組織ID").notRequired(),
  name: validator.string().emptyToNull().trim().max(200).label("組織名").notRequired(),
  productId: validator.string().isSelection().emptyToNull().label("契約サービス").notRequired(),
  lastLoginFrom: validator
    .mixed()
    .isDayjs(invalidDate("最終ログイン"))
    .isSelection()
    .isBeforeDate("lastLoginTo", invalidDate("最終ログイン"))
    .label("最終ログイン開始日")
    .notRequired(),
  lastLoginTo: validator
    .mixed()
    .isDayjs(invalidDate("最終ログイン"))
    .isSelection()
    .isAfterDate("lastLoginFrom", invalidDate("最終ログイン"))
    .label("最終ログイン終了日")
    .notRequired(),
  createdDateFrom: validator
    .mixed()
    .isDayjs(invalidDate("登録開始日"))
    .isSelection()
    .isBeforeDate("createdDateTo", invalidDate("登録日"))
    .label("登録開始日")
    .notRequired(),
  createdDateTo: validator
    .mixed()
    .isDayjs(invalidDate("登録日"))
    .isSelection()
    .isAfterDate("createdDateFrom", invalidDate("登録日"))
    .label("登録終了日")
    .notRequired(),
});
